module.exports = __webpack_public_path__ + "public/media/behance.png";


//////////////////
// WEBPACK FOOTER
// ./images/behance.png
// module id = ./images/behance.png
// module chunks = 0